import { LoadingButton } from '@mui/lab';
import { useGatewayListing } from 'api/apiHooks';
import React from 'react';
import { setSession } from 'utils/jwt';
import GatewayDetailsOnboarding from './GatewayDetailsOnboarding';

export default function SelectGatewayScreen({
  gatewayConfig,
  loadingUserSubmit,
  onSubmit,
  handleOurPaymentKeys,
  loadingOurPaymentKeys,
  methodSelected,
  setMethodSelected,
  stripeKeyError,
  payPalKeyError,
  userToken,
  setUserToken,
}: {
  stripeKeyError: any;
  payPalKeyError: any;
  gatewayConfig: [
    string | null,
    React.Dispatch<React.SetStateAction<string | null>>
  ];
  loadingUserSubmit: boolean;
  loadingOurPaymentKeys: boolean;
  handleOurPaymentKeys: VoidFunction;
  onSubmit: (data: any) => void;
  methodSelected: string;
  setMethodSelected: React.Dispatch<React.SetStateAction<string>>;
  userToken: string | null;
  setUserToken: React.Dispatch<React.SetStateAction<string | null>>;
}) {
  const { data } = useGatewayListing();
  setSession(window.sessionStorage.getItem('user_token'));
  setUserToken(window.sessionStorage.getItem('user_token'));
  const paymentSelected = data?.data.find(
    gateway => gateway.name === methodSelected
  );

  return (
    <div className='flex gap-[10%] flex-col items-center justify-center'>
      <div className='min-w-[600px]'>
        <h3>Setup Payment</h3>
        <div className='grid grid-cols-2 gap-[5%] mt-5'>
          <label
            htmlFor='stripe-select-onboard'
            className={`flex items-center cursor-pointer justify-between border-[1px] p-2 rounded-md border-solid border-gray-200 ${
              paymentSelected?.name === 'stripe' ? 'bg-gray-100' : ''
            }`}
          >
            <span>
              <input
                name='gateway'
                id='stripe-select-onboard'
                type='radio'
                value='stripe'
                checked={methodSelected === 'stripe'}
                onChange={e => setMethodSelected(e.target.value)}
              ></input>
              <span className='ml-1'>Stripe</span>
            </span>
            <img
              className='max-w-[70px] max-h-[25px]'
              src={'/images/icons/stripe-mini.png'}
              alt='stripe-logo'
            />
          </label>
          <label
            htmlFor='paypal-select-onboard'
            className={`flex cursor-pointer items-center justify-between border-[1px] p-2 rounded-md border-solid border-gray-200 ${
              paymentSelected?.name === 'paypal' ? 'bg-gray-100' : ''
            }`}
          >
            <span>
              <input
                name='gateway'
                id='paypal-select-onboard'
                type='radio'
                value='paypal'
                checked={methodSelected === 'paypal'}
                onChange={e => setMethodSelected(e.target.value)}
              ></input>
              <span className='ml-1'>Paypal</span>
            </span>
            <img
              className='max-w-[70px] max-h-[25px]'
              src={'/images/icons/paypal-mini.png'}
              alt='paypal-logo'
            />
          </label>
        </div>
        <div className='mt-3 w-full'>
          <LoadingButton
            variant='outlined'
            onClick={handleOurPaymentKeys}
            loading={loadingOurPaymentKeys}
            className='w-full'
          >
            Use our {paymentSelected?.label} test keys
          </LoadingButton>
        </div>

        {paymentSelected?._id && (
          <GatewayDetailsOnboarding
            onSubmit={onSubmit}
            loadingUserSubmit={loadingUserSubmit}
            paymentSelected={paymentSelected}
            stripeKeyError={stripeKeyError}
            payPalKeyError={payPalKeyError}
          />
        )}
      </div>
    </div>
  );
}
